import type { ICountryDefinition } from "@/countries/country-common";

import { EAddressProvider } from "@/domains/address/providers/address-provider.types.ts";
import { ECountry, ECountryCode, ELanguageCode } from "@/domains/country/country.types.ts";

export const CZECH_DATABASE_COUNTRY_ID = 16;

export const CzechCountryDefinition = {
  addressProvider: EAddressProvider.GOOGLE,
  countryCode: ECountryCode.CZECH,
  languageCode: ELanguageCode.CZECH,
  country: ECountry.CZECH,
  phoneAllowed: true,
  addressAllowed: true,
  phone: {
    mask: "+420 999 999 999",
    placeholder: "+420 999 999 999",
    prefix: "+420",
  },
  databaseCountryId: CZECH_DATABASE_COUNTRY_ID,
} as const satisfies ICountryDefinition;
